// extracted by mini-css-extract-plugin
module.exports =  {"root":"rxW_7I18_X6_lO7ZMHRg","input":"b8keguwY3vqfKC1cewDU","suffix":"u8Lz7ZLBkTTXKxEvU6e1","icon":"pURD1zQ2qcE9L8btBjEk"};